import { render, staticRenderFns } from "./key-figures.vue?vue&type=template&id=d6363e26&"
import script from "./key-figures.vue?vue&type=script&lang=js&"
export * from "./key-figures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports